// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import { ArrayPage } from "../../core/pagination.mjs";
import { path } from "../../internal/utils/path.mjs";
export class Blocks extends APIResource {
    /**
     * Retrieve a core memory block from an agent.
     */
    retrieve(blockLabel, params, options) {
        const { agent_id } = params;
        return this._client.get(path `/v1/agents/${agent_id}/core-memory/blocks/${blockLabel}`, options);
    }
    /**
     * Updates a core memory block of an agent.
     */
    update(blockLabel, params, options) {
        const { agent_id, ...body } = params;
        return this._client.patch(path `/v1/agents/${agent_id}/core-memory/blocks/${blockLabel}`, {
            body,
            ...options,
        });
    }
    /**
     * Retrieve the core memory blocks of a specific agent.
     */
    list(agentID, query = {}, options) {
        return this._client.getAPIList(path `/v1/agents/${agentID}/core-memory/blocks`, (ArrayPage), { query, ...options });
    }
    /**
     * Attach a core memory block to an agent.
     */
    attach(blockID, params, options) {
        const { agent_id } = params;
        return this._client.patch(path `/v1/agents/${agent_id}/core-memory/blocks/attach/${blockID}`, options);
    }
    /**
     * Detach a core memory block from an agent.
     */
    detach(blockID, params, options) {
        const { agent_id } = params;
        return this._client.patch(path `/v1/agents/${agent_id}/core-memory/blocks/detach/${blockID}`, options);
    }
}
//# sourceMappingURL=blocks.mjs.map